import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ConsoleMessage {
  id: string;
  type: 'log' | 'error' | 'warn' | 'info';
  message: string;
  timestamp: string; // ISO string instead of Date object
  stack?: string;
}

interface ConsoleState {
  messages: ConsoleMessage[];
  maxMessages: number;
}

const initialState: ConsoleState = {
  messages: [],
  maxMessages: 300,
};

const consoleSlice = createSlice({
  name: 'console',
  initialState,
  reducers: {
    addConsoleMessage: (state, action: PayloadAction<Omit<ConsoleMessage, 'id' | 'timestamp'>>) => {
      const newMessage: ConsoleMessage = {
        id: Date.now() + Math.random().toString(),
        timestamp: new Date().toISOString(),
        ...action.payload,
      };
      
      state.messages.unshift(newMessage);
      
      // Keep only the latest maxMessages
      if (state.messages.length > state.maxMessages) {
        state.messages = state.messages.slice(0, state.maxMessages);
      }
    },
    clearConsoleMessages: (state) => {
      state.messages = [];
    },
    setMaxMessages: (state, action: PayloadAction<number>) => {
      state.maxMessages = action.payload;
      if (state.messages.length > state.maxMessages) {
        state.messages = state.messages.slice(0, state.maxMessages);
      }
    },
  },
});

export const { addConsoleMessage, clearConsoleMessages, setMaxMessages } = consoleSlice.actions;

export const getConsoleMessages = (state: RootState) => state.console.messages;
export const getMaxMessages = (state: RootState) => state.console.maxMessages;

export default consoleSlice.reducer; 